function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpecialEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.965462,
    height: 44.239371,
    viewBox: "0 0 508.965462 440.239371",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M231.117092,0c25.280231,1.449017,49.316929,7.068647,73.459188,13.790974,36.874619,10.267738,74.141735,19.304668,111.568857,27.344141,23.993958,5.154058,48.556849,7.702012,72.899169,11.176655,16.15519,2.306066,24.774764,16.495766,17.05949,29.861276-25.788705,44.674621-39.493555,93.677821-52.109939,143.106861-6.575046,25.760677-10.533841,52.530893-20.084561,77.13298-48.885129,125.924897-202.857172,176.546355-317.625924,105.344211-21.356659-13.249747-45.321086-16.812072-69.445841-19.860124-8.686261-1.097273-17.541117-.948113-26.324026-1.170403-16.228965-.410752-24.005663-13.094574-19.017893-28.639596,6.407631-19.970947,11.480773-40.375304,16.940828-60.643496,4.021938-14.929483-2.193365-28.965943-4.471135-43.274626C-4.153229,140.349128,71.333733,30.093713,184.210555,6.464331c15.411218-3.226152,31.26025-4.361171,46.906537-6.464331ZM418.298338,221.808862c1.262755-102.25895-82.301695-187.016409-185.62726-188.277392-103.440038-1.262379-187.69015,81.221121-189.251332,185.282818-1.539704,102.634963,81.693782,187.962374,184.518174,189.159838,104.541821,1.217546,189.067379-81.445183,190.360417-186.165265Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.893658,220.021417c-.115118,49.164226-13.936268,92.609596-36.086189,133.603338-10.0302,18.563113-33.632091,18.23-43.793624-.381866-48.066523-88.039236-47.517135-176.135441.570114-263.971825,9.264106-16.921928,33.131241-17.286451,42.483619-.340361,22.830965,41.368198,36.658558,85.400434,36.826081,131.090714Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecialEye);
export default __webpack_public_path__ + "static/media/special_eye.5a7347e156f2692b8719a3b7dc75d963.svg";
export { ForwardRef as ReactComponent };